import { useTranslation } from 'react-i18next';

type UseConfigurationDataReturnType = {
  configurationData: { label: string; value: string }[];
};

export const useConfigurationData = (): UseConfigurationDataReturnType => {
  const { t } = useTranslation('venueDetails');

  const configurationOptions = [
    'FULL_HOUSE',
    'HALF_HOUSE',
    'GA_FLOOR_ONLY',
  ] as const;

  const configurationData = configurationOptions.map((option) => ({
    label: t(`CONFIGURATIONS.${option}`, { ns: 'venueDetails' }),
    value: option,
  }));

  return { configurationData };
};
